import { user_state, theme_color, user_data, inbox_count } from "./StateTypes";

const user_login = (loginState) => {
    return {
        type: user_state,
        payload: loginState
    };
};

export const theme_color_change = (color) => {
    return {
        type: theme_color,
        payload: color
    };
};

export const setUserLoginData = (usersData) => {
    return {
        type: user_data,
        payload: usersData
    };
};

export const setInboxCount = (count) => {
    return {
        type: inbox_count,
        payload: count
    };
};

export default user_login;